// extracted by mini-css-extract-plugin
module.exports = {"reference":"aw"};